var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTsCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.3243,
    height: 24.3243,
    rx: 4.86486,
    fill: "#336AE9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_299_1303",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_299_1303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.18849C11.1501 9.18849 10.4282 8.89141 9.83415 8.29724C9.23998 7.70321 8.94289 6.97953 8.94289 6.1262C8.94289 5.273 9.23998 4.54974 9.83415 3.95641C10.4282 3.36307 11.1501 3.06641 12 3.06641C12.8498 3.06641 13.5718 3.36307 14.1658 3.95641C14.76 4.54974 15.0571 5.273 15.0571 6.1262C15.0571 6.97953 14.76 7.70321 14.1658 8.29724C13.5718 8.89141 12.8498 9.18849 12 9.18849ZM10.7069 19.641L6.75269 15.6987C6.46727 15.408 6.24331 15.0624 6.08081 14.6618C5.91817 14.2611 5.83685 13.8063 5.83685 13.2974C5.83685 12.4215 6.14685 11.6735 6.76685 11.0535C7.38685 10.4335 8.13671 10.1235 9.01644 10.1235C9.43158 10.1235 9.82033 10.2118 10.1827 10.3883C10.545 10.5647 10.8721 10.7988 11.1639 11.0906L12 11.9266L12.836 11.0906C13.1174 10.8092 13.4419 10.5777 13.8094 10.396C14.177 10.2143 14.5684 10.1235 14.9835 10.1235C15.8632 10.1235 16.6144 10.4335 17.2371 11.0535C17.8596 11.6735 18.1708 12.4215 18.1708 13.2974C18.1708 13.8063 18.0882 14.2611 17.9231 14.6618C17.758 15.0624 17.5327 15.408 17.2473 15.6987L13.2931 19.641C13.108 19.8165 12.9038 19.9479 12.6806 20.0349C12.4574 20.122 12.2303 20.1656 11.9994 20.1656C11.7682 20.1656 11.5413 20.122 11.3185 20.0349C11.0956 19.9479 10.8917 19.8165 10.7069 19.641Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsCard);
export default __webpack_public_path__ + "static/media/ts_card.bb38885d6a0391ce07d9db71376f2de2.svg";
export { ForwardRef as ReactComponent };